import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';

type Placement = 'left' | 'center' | 'right';


export default /*#__PURE__*/_defineComponent({
  __name: 'PopoverModal',
  props: {
    cssClass: null,
    boundingElement: null,
    anchor: { default: 'center' },
    position: { default: 'center' },
    enableArrow: { type: Boolean, default: false },
    bottomGutter: { default: 5 },
    popoverPadding: { default: 10 }
  },
  setup(__props: any) {

const props = __props as { cssClass?: any, boundingElement?: HTMLElement, anchor: Placement, position: Placement, enableArrow: boolean, bottomGutter: number, popoverPadding: number };



const popover = ref<HTMLElement | null>(null);
const popoverWidth = ref(0);

let observer: ResizeObserver | null = null;

onMounted(async () => {
	if (!popover.value) return;

	// Wait for DOM to fully render with content
	await nextTick();

	if (popover.value) {
		popoverWidth.value = popover.value.offsetWidth;
	}

	observer = new ResizeObserver(() => {
		if (popover.value) popoverWidth.value = popover.value.offsetWidth;
	});

	if (popover.value) {
		observer.observe(popover.value);
	}
});

onBeforeUnmount(() => {
	if (observer) {
		observer.disconnect();
	}
});

const style = computed(() => {
	if (!props.boundingElement || !popover.value) return {};

	let data: any = {};
	let anchorX = 0;

	const rect = props.boundingElement.getBoundingClientRect();
	switch (props.anchor) {
		case 'left':
			anchorX = rect.left;
			break;
		case 'right':
			anchorX = rect.left + rect.width;
			break;
		default:
			anchorX = rect.left + rect.width / 2;
			break;
	}

	if (popoverWidth.value >= window.innerWidth) {
		data = { left: `${props.popoverPadding}px`, right: `${props.popoverPadding}px` };
	}

	let left: number;

	switch (props.position) {
		case 'left':
			left = anchorX;
			break;
		case 'right':
			left = anchorX - popoverWidth.value;
			break;
		default:
			left = anchorX - popoverWidth.value / 2;
			break;
	}

	if (left < 0) {
		data = { left: `${props.popoverPadding}px` };
	} else if (left + popoverWidth.value > window.innerWidth) {
		data = { right: `${props.popoverPadding}px` };
	} else {
		data = { left: `${left}px` };
	}

	if (props.enableArrow) {
		// Calculate arrow position relative to popover
		// Arrow should point to anchorX (button center)
		const popoverLeft = data.left
			? parseFloat(data.left)
			: data.right
			? window.innerWidth - popoverWidth.value
			: left;
		const arrowPosition = anchorX - popoverLeft;
		data['--arrow-left'] = `${arrowPosition}px`;
	}

	const topPosition = rect.bottom + props.bottomGutter;
	const maxHeight = window.innerHeight - topPosition - props.popoverPadding;

	return {
		...data,
		top: `${topPosition}px`,
		maxHeight: `${maxHeight}px`,
	};
});

return { __sfc: true,props, popover, popoverWidth, observer, style }
}

})